document.addEventListener('DOMContentLoaded', function() {
    const storedProductHandles = JSON.parse(localStorage.getItem('recently-viewed-products')) || [];
    if (storedProductHandles.length > 0) {
        const url = `/pages/contact?view=recently-view&product_list=${storedProductHandles.join(',')}`;

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data;

                const listItems = tempDiv.querySelectorAll('.recently-view-list'); // Assuming your products are returned as <li> elements
                const swiperWrapper = document.querySelector('.recent-view-product-list');

                // Clear existing slides
                swiperWrapper.innerHTML = '';

                // Append each item to the swiper wrapper
                listItems.forEach(item => {
                    if (item.getAttribute('var-id')) { // Check if the item has a 'var-id' attribute
                        swiperWrapper.appendChild(item);
                    }
                });

                // Show the recently viewed products section if there are items
                if (swiperWrapper.children.length > 0) {
                    document.getElementById('recently-viewed-products').style.display = 'block';
                    setTimeout(initializeSwiper, 100); // Initialize Swiper after a delay
                } else {
                    document.getElementById('recently-viewed-products').style.display = 'none';
                }
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    } else {
        document.getElementById('recently-viewed-products').style.display = 'none';
    }
});

function initializeSwiper() {
    const swiper = new Swiper(".swiper-container", {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 42, 
        loop: false, 
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            750: {
                slidesPerView: 2
            },
            991: {
                slidesPerView: 4
            }
            
        }
    });
}